import React, { useEffect, useState } from "react";
import { userProfile } from "../api/Api";
import { userId, userToken } from "../../Utils/userAuth";
import "./WtPrev9.css";
import {
  FiPackage,
  FiMessageSquare,
  FiHeadphones,
  FiZap,
  FiSend,
  FiShoppingCart,
} from "react-icons/fi";

const WtPrev9 = (props) => {
  const [inputVal, setInputVal] = useState("");
  const [parent_id, setParent_id] = useState(null);
  const [parentType, setParentType] = useState(null);
  const [brandName, setBrandName] = useState("");

  useEffect(() => {
    const siteSettings = localStorage.getItem("siteSettings");
    if (siteSettings) {
      const parsed = JSON.parse(siteSettings);
      setBrandName(parsed.brand_name || "");
    }
  }, []);

  useEffect(() => {
    const storedLogin = localStorage.getItem("login");
    if (storedLogin) {
      const parsed = JSON.parse(storedLogin);
      setParentType(parsed?.user?.parent_type || null);
    }

    const paramData = {
      user_id: userId,
      token: userToken,
      method: "retrieve",
    };

    userProfile(paramData).then((result) => {
      if (result.data.success === true) {
        setParent_id(result.data.data[0].parent);
      }
    });
  }, []);

  const toggleWidget = () => {
    const td = document.getElementById("authkey-tgl");
    if (!td) return;
    td.classList.toggle("authkey-ds9");
    td.classList.toggle("authkey-dh9");
  };

  const closeWidget = () => {
    const td = document.getElementById("authkey-tgl");
    if (!td) return;
    td.classList.remove("authkey-ds9");
    td.classList.add("authkey-dh9");
  };

  const sendMessage = () => {
    const encodedText = encodeURIComponent(inputVal);
    const url = `https://wa.me/${props.mobile_no}?text=${encodedText}`;
    window.open(url, "_blank");
  };

  return (
    <div>
      <div
        className="wt9-wrapper"
        style={{
          [props.position]: `${props.sidemargin}px`,
          bottom: `${props.marginbottom}px`,
        }}
      >
        {/* Widget Card */}
        <div
          id="authkey-tgl"
          className={`wt9-card ${
            props.wtstatus === "yes" ? "authkey-ds9" : "authkey-dh9"
          }`}
        >
          <div className="wt9-card-inner">
            {/* Header */}
            <div
              className="wt9-header"
              style={{
                background:
                  props.bgcolor || "linear-gradient(180deg,#0fa054,#0da34b)",
              }}
            >
              <div className="wt9-avatar-area">
                <div className="wt9-avatar">
                  <img
                    src={props.logourl}
                    alt="avatar"
                    className="wt9-avatar-img"
                  />
                  <span className="wt9-avatar-online" />
                </div>
              </div>

              <div className="wt9-title-area">
                <div className="wt9-title">
                  {props.displayname}
                </div>
                <div className="wt9-subtitle">Online</div>
              </div>

              <button className="wt9-close" onClick={closeWidget} aria-label="close">
                ×
              </button>
            </div>

            {/* Body */}
            <div className="wt9-body">
            <div className="wt9-info-card">
    <div className="wt9-msg-title">Support Team</div>

    <div className="wt9-msg-line">Hi! 👋</div>
    <div className="wt9-msg-line">How can I help you today?</div>

    <div className="wt9-msg-time">Just now</div>
</div>


              

              <div className="wt9-input-row">
                <input
                  id="authkey-message-input9"
                  className="wt9-input"
                  placeholder="Type your message..."
                  value={inputVal}
                  onChange={(e) => setInputVal(e.target.value)}
                />
                <button
                  className="wt9-send"
                  onClick={sendMessage}
                  aria-label="send"
                >
                  <FiSend />
                </button>
              </div>

              {!props.removeBranding && (
              <div className="wt9-footer">
                <div className="wt9-footer-inner">
                  {parentType === "reseller" ? (
                    parent_id === 10774 ? (
                      <p className="wt9-brand">
                        by <span>adznetworkmedia.om</span>
                      </p>
                    ) : parent_id === 5643 ? (
                      <p className="wt9-brand">
                        by <span>cpaasnettyfish.com</span>
                      </p>
                    ) : brandName && brandName.trim() !== "" ? (
                      <p className="wt9-brand">
                        by <span>{brandName}</span>
                      </p>
                    ) : null
                  ) : (
                    <p className="wt9-brand">
                      <span className="wt9-text">Powered by </span>
                      <a
                        href="https://authkey.io"
                        target="_blank"
                        rel="noreferrer"
                        className="wt9-link"
                      >
                        Authkey.io
                      </a>
                    </p>
                  )}
                </div>
              </div>
              )}
            </div>
          </div>
        </div>

        {/* Floating Button */}
         <button
           className="wt9-float-btn"
          style={{ float: `${props.position}` }}
          id="authkey-wt-btn"
          onClick={toggleWidget}
        >
          <svg viewBox="0 0 32 32" className="authkey-whatsappIcon9">
            <path
              d=" M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.15-.515 2.478-1.318.13-.33.244-.73.244-1.088 0-.058 0-.144-.03-.215-.1-.172-2.434-1.39-2.678-1.39zm-2.908 7.593c-1.747 0-3.48-.53-4.942-1.49L7.793 24.41l1.132-3.337a8.955 8.955 0 0 1-1.72-5.272c0-4.955 4.04-8.995 8.997-8.995S25.2 10.845 25.2 15.8c0 4.958-4.04 8.998-8.998 8.998zm0-19.798c-5.96 0-10.8 4.842-10.8 10.8 0 1.964.53 3.898 1.546 5.574L5 27.176l5.974-1.92a10.807 10.807 0 0 0 16.03-9.455c0-5.958-4.842-10.8-10.802-10.8z"
              fillRule="evenodd"
            ></path>
          </svg>
          <span className="authkey-whatsappLive9"></span>
        </button>
      </div>
    </div>
  );
};

export default WtPrev9;
